import { useQuery } from 'react-query';
import { ENTITY } from '../constants';
import { RegionApi } from '../apis';

type QueryData = {
  id: number;
  name: {
    uz: string;
    oz: string;
    ru: string;
    en: string;
  };
};
const useRegion = () => {
  return useQuery<QueryData[], Error, QueryData[]>({
    queryKey: [ENTITY, 'region'],
    async queryFn() {
      const { data } = await RegionApi();
      return data.data;
    },
    initialData: [],
    retry: false
  });
};

export default useRegion;
